var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$route.name && !_vm.$route.name.includes('admin-'))?[_c('Menu'),_c('Drawer'),_c('Jumbotron')]:_vm._e(),_c('Vista'),(_vm.$route.name && !_vm.$route.name.includes('admin-'))?[_c('MenuFooter'),_c('Footer')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }